import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from "@angular/core";
import { isNumber } from "@progress/kendo-angular-grid/dist/es2015/utils";
import { BaseFormComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-form.component";
import { SelectorService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/selector.service";
import { form_control, Lookup } from "projects/sepidz-web-framework/src/lib/models";
import { MapObjectPipe } from "projects/sepidz-web-framework/src/lib/pipes/mapobject.pipe";
import { LookupService } from "projects/sepidz-web-framework/src/lib/services";
import { takeUntil } from "rxjs/operators";
import { Invoice } from "src/app/frontoffice/order/model/invoice.model";
import { ReceiptPaymentModel } from "src/app/frontoffice/order/model/receiptpayment.model";
import { RowState } from "../../../../../../projects/sepidz-web-framework/src/lib/models/enums";
import { CustomerSettlementModel, SettlementType } from "../../model/usersettlement.model";
import { FormControlTypes } from "projects/sepidz-web-framework/src/lib/models/form-base-control.model";
import { PaymentMethodType } from "../../model/payment-method.enum";

@Component({
  selector: "ngx-customer-receipt-payment-form",
  templateUrl: "./customer-receipt-payment-form.component.html",
  styleUrls: ["./customer-receipt-payment-form.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CustomerReceiptPaymentFormComponent extends BaseFormComponent<CustomerSettlementModel> {
  settlement: CustomerSettlementModel;
  settlementType: Lookup[];
  debitTitle: string = this.translate("ClientApp.FrontOffice.Financial.CustomerReceiptPayment.debitTitle");
  receiptPaymentType: Lookup[];

  constructor(protected selectorService: SelectorService, private lookupservice: LookupService, protected cd: ChangeDetectorRef) {
    super(selectorService, cd);
    this.FillData();
  }
  async ngOnInit() {
    this.apiName = "CustomerSettlemet";
    this.label = this.translate("ClientApp.FrontOffice.Financial.ReceiptPayments");
    this.detailName = "ReceiptPayments";
    this.ignoreFormGroupWithDetailName = true;
    super.ngOnInit();
  }
  async FillData() {
    this.lookupservice
      .getLookupbyCategory("SALE", "SettlementType")
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(async (data) => {
        this.settlementType = data;
      });

    this.lookupservice
      .getLookupbyCategory("SALE", "ReceiptPaymentType")
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((data: Lookup[]) => {
        this.receiptPaymentType = data;
      });
  }

  setdefault() {
    if (!this.model.BranchId) this.model.BranchId = this.accountService.authService.currentBranchId;
    if (this.currentrow) {
      this.settlement = this.currentrow;
      this.model = JSON.parse(JSON.stringify(this.model[this.detailName][0]));
    }
  }
  addControl() {
    this.setValue("CustomerId", this.model.CustomerNumber, true);
    this.orignalColumns.find((f) => f.modelName === "CustomerId").required = true;
    const CustomerId = this.columns.find((f) => f.modelName === "CustomerId");
    CustomerId.required = true;
    CustomerId["defaultSortKey"] = "Number";
    CustomerId["defaultSortKeyKind"] = "asc";
    CustomerId.isFloat = 1;
    this.columns.find((f) => f.modelName === "Amount").isFloat = 1;

    this.columns.find((f) => f.modelName === "PaymentMethodId").apiName =
      "PaymentMethod/PaymentMethodLookUp/" + this.accountService.authService.currentBranchId;

    this.cd.markForCheck();
    this.onCustomerIdChanges();
    this.setColumnAttribute();
  }

  beforupdate() {
    this.getDataFromFormGroup();
    if (this.currentrow) {
      this.settlement.ReceiptPayments[0] = JSON.parse(JSON.stringify(this.model));
      this.settlement.State = RowState.Modify;
      this.settlement.ReceiptPayments[0].State = RowState.Modify;
      this.setValue("Id", this.settlement.Id);
    } else {
      this.settlement = new CustomerSettlementModel();
      const receipt = new ReceiptPaymentModel();
      let mapper = new MapObjectPipe();
      this.settlement.ReceiptPayments[0] = JSON.parse(JSON.stringify(mapper.transform(this.model, receipt)));
      this.settlement.State = RowState.New;
      this.settlement.ReceiptPayments[0].State = RowState.New;
    }
    this.settlement.FiscalYearId = this.accountService.authService.currentFiscalYear.Id;
    this.model = JSON.parse(JSON.stringify(this.settlement));
    this.model.SettlementTypeId = this.settlementType.find((f) => f.Code === SettlementType.CustomerSettlement).Id;
  }

  ngAfterViewInit(): void {
    this.FillData();
  }

  setColumnAttribute() {
    super.setColumnAttribute();
    if (!this.orignalColumns.some((s) => s.name === "AppliedToFundBalance")) {
      const ctrl = new form_control();
      ctrl.name = "AppliedToFundBalance";
      ctrl.label = this.translate("ClientApp.FrontOffice.Financial.CustomerReceiptPayment.ApplicationsFundBalance");
      ctrl.modelName = "AppliedToFundBalance";
      ctrl.order = 5;
      ctrl.tabOrder = 6;
      ctrl.columnNumber = 1;
      ctrl.formVisible = true;
      ctrl.controlType = FormControlTypes.checkbox;
      this.orignalColumns.push(ctrl);
      this.orignalColumns.find((f) => f.name === "ReceiptPaymentTypeId").isFloat = 1;
    }
    this.columns = this.orignalColumns.filter(
      (f) => ((!f.areaName || f.areaName === "default") && f.formVisible) || (f.DetailControlModels && f.DetailControlModels[f.name].length > 0)
    );
    this.columns = this.columns.sort((a, b) => a.order - b.order);
  }

  private onCustomerIdChanges() {
    this.formGroup
      .get("CustomerId")
      .valueChanges.pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(($event) => {
        if ($event !== 0 && isNumber($event) && this.formGroup.controls["DebitTotal"].value !== $event) {
          const invoice = new Invoice();
          invoice.CustomerId = $event;
          this.httpCommonService
            .create(`Invoice/GetCredit`, invoice)
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe((data) => {
              this.setValue("DebitTotal", data);
              if (data < 0) {
                this.debitTitle = this.translate("ClientApp.FrontOffice.Financial.CustomerReceiptPayment.credit");
              } else {
                this.debitTitle = this.translate("ClientApp.FrontOffice.Financial.CustomerReceiptPayment.debitTitle");
              }
              this.columns.find((f) => f.modelName === "DebitTotal").label = this.debitTitle;
              this.cd.markForCheck();
            });
          this.cd.markForCheck();
        }
      });
  }
}
